import $ from 'jquery';

let _translations: Map<string, string> = new Map();

function _unescapeUnicodeChar (escapedChar: string): string {
  const code = parseInt(escapedChar.substring(2), 16);
  if (code >= 0 && code < Math.pow(2, 16)) {
    return String.fromCharCode(code);
  }
  return '';
}

function _parseData (data: string): void {
  const lines: string[] = data.split(/\n/);
  
  for (let lineIndex = 0; lineIndex < lines.length; lineIndex++) {
    const line: string = lines[lineIndex];
    const trimmedLine: string = line.trim();
    if (trimmedLine.length > 0 && !trimmedLine.startsWith('#')) { // skip comments
      const [keyToTrim, ...values] = trimmedLine.split('=');
      const key = keyToTrim.trim();
      let value = values.join('=');

      // process multi-line values
      while (value.endsWith('\\')) {
        value = value.substring(0, value.length - 1);
        value += lines[++lineIndex].trimRight();
      }

      value = value.replace(/(\\u.{4})/ig, _unescapeUnicodeChar);
      value = value.replace(/\\t/g, '\t');
      value = value.replace(/\\r/g, '\r');
      value = value.replace(/\\n/g, '\n');
      value = value.replace(/\\f/g, '\f');
      value = value.replace(/\\\\/g, '\\');
      value = value.trim();

      _translations.set(key, value);
    }
  }
}

function _fetch (filename: string, done: () => void) {
  $.ajax({
    url: filename,
    async: true,
    cache: true,
    dataType: 'text',
    success: function (data, status) {
      _parseData(data);
      done();
    },
    error: function (jqXHR, textStatus, errorThrown) {
      done();
    }
  });
}

function _loadAndParseFiles (fileNames: string[], onSuccess: () => void) {
  if (fileNames.length > 0) {
    _fetch(fileNames[0], () => {
      fileNames.shift();
      _loadAndParseFiles(fileNames, onSuccess);
    });
  } else {
    onSuccess();
  }
}

function initialize (
  languageFiles: string | string[],
  language: string,
  onSuccess: () => void
): void {
  const files: string[] = Array.isArray(languageFiles) ? languageFiles : [languageFiles];

  const languageWithoutCountry: string = language.split('_')[0];
  const languageWithCounty: string = language;

  let languageFilesToFetch: string[] = [];

  files.forEach(file => {
    const defaultFile: string = file + '.properties';
    languageFilesToFetch.push(defaultFile);

    if (languageWithoutCountry !== 'en') {
      const languageFile: string = file + '_' + languageWithoutCountry + '.properties';
      languageFilesToFetch.push(languageFile);
    }

    if (languageWithCounty !== languageWithoutCountry) {
      const languageAndCountryFile: string = file + '_' + languageWithCounty + '.properties';

      languageFilesToFetch.push(languageAndCountryFile);
    }
  });

  _loadAndParseFiles(languageFilesToFetch, onSuccess);
}

function translate (
  stringToTranslate: string,
  ...rest: any
  ): string {
  const translation: string | undefined = _translations.get(stringToTranslate);
  if (translation != null) {
    let translated: string = translation;
    for(let paramIndex = 0; paramIndex < rest.length ; paramIndex++) {
      translated = translated.replace(new RegExp('\\{' + paramIndex + '\\}', 'g'), rest[paramIndex]);
    }
    
    return translated;
  }

  return '[' + stringToTranslate + ']';
}

export default {
  initialize,
  translate
};
